import React, { useState, useEffect } from 'react';
import { db } from '../lib/firebase';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';
import { Link } from 'react-router-dom';

interface WebStory {
  id: string;
  title: string;
  coverImage: string;
}

export function WebStoriesRow() {
  const [stories, setStories] = useState<WebStory[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStories = async () => {
      try {
        const q = query(collection(db, 'web_stories'), orderBy('createdAt', 'desc'), limit(10));
        const snap = await getDocs(q);
        const fetched: WebStory[] = [];
        snap.forEach(d => fetched.push({ id: d.id, ...d.data() } as WebStory));
        setStories(fetched);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchStories();
  }, []);

  if (loading || stories.length === 0) return null;

  return (
    <div className="mb-6 w-full -mx-4 px-4 overflow-hidden relative font-bengali">
       <div className="flex items-center justify-between mb-3 px-1">
         <h2 className="text-lg font-bold font-bengali text-[#111111] dark:text-white flex items-center">
           <span className="w-1 h-5 bg-[#D32F2F] rounded-full mr-2"></span>
           ওয়েব স্টোরিজ
         </h2>
       </div>
       <div className="-mx-4 px-4">
         <div className="flex overflow-x-auto gap-3 pb-2 snap-x snap-mandatory scrollbar-hide">
           {stories.map((story) => (
             <Link 
               to={`/stories/${story.id}`} 
               key={story.id} 
               className="w-[100px] sm:w-[130px] aspect-[9/16] shrink-0 snap-start relative rounded-xl overflow-hidden shadow-sm group bg-gray-100"
             >
               <img 
                 src={story.coverImage} 
                 alt={story.title} 
                 className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" 
               />
               <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent flex flex-col justify-end p-2 sm:p-3">
                 <h3 className="text-white text-xs sm:text-sm font-bold line-clamp-3 leading-snug drop-shadow-md">
                   {story.title}
                 </h3>
               </div>
             </Link>
           ))}
         </div>
       </div>
    </div>
  );
}
